<template>
  <component
    :is="resolvedComponent"
    :target="external ? '_blank' : undefined"
    :to="to"
    :class="[
      'flex items-center justify-center rounded-md cursor-pointer font-bold transition-all duration-300 ease-out disabled:cursor-not-allowed disabled:opacity-50',
      {
        'bg-theme-100 text-white hover:not-disabled:bg-theme-90 hover:not-disabled:active:bg-theme-80':
          variant === 'theme',
        'bg-theme-30 text-theme-100 hover:not-disabled:bg-theme-40 hover:not-disabled:active:bg-theme-50':
          variant === 'theme-inverse',
        'bg-primary-90 text-white hover:not-disabled:hover:bg-primary-80 hover:not-disabled:active:bg-primary-70':
          variant === 'primary',
        'bg-head-office-40 text-primary-100 hover:not-disabled:hover:bg-head-office-80 hover:not-disabled:active:bg-head-office-60':
          variant === 'secondary',
        'bg-primary-90 text-white hover:not-disabled:bg-primary-70 hover:not-disabled:active:bg-primary-50':
          variant === 'top-nav',
        'bg-white text-primary-100 hover:not-disabled:bg-theme-70 hover:not-disabled:active:bg-theme-90':
          variant === 'white',
        'bg-white text-primary-100 hover:not-disabled:bg-primary-90 hover:not-disabled:active:bg-primary-90 hover:not-disabled:text-white hover:not-disabled:active:text-white':
          variant === 'tag-white', // Used for /actueel page

      },
      {
        'text-caption px-2.5 py-2': size === 'xs',
        'text-caption px-5 py-2.25': size === 'sm',
        'text-caption md:text-base px-4 py-2.5 leading-[20px] md:text-[16px] md:leading-[22px]': size === 'compact',
        'text-body px-8 py-2.5': size === 'md',
        'text-body px-16 py-5': size === 'lg',
        'text-body p-3': size === 'square',
        'text-body-medium w-full max-w-100 px-16 py-2.5': size === 'wide',
      },
    ]">
    <slot/>
  </component>
</template>

<script lang="ts" setup>
import { CustomNuxtLink } from '@gro-up/ui/primitives'
import type { ButtonVariant } from '@gro-up/ui/types'
import type { NuxtLinkProps } from 'nuxt/app'
import { computed } from 'vue'

type ButtonComponentType = 'button' | 'span' | 'NuxtLink'

const props = withDefaults(
  defineProps<{
    variant: ButtonVariant
    size?: 'xs' | 'sm' | 'compact' | 'md' | 'lg' | 'square' | 'wide'
    as?: ButtonComponentType
    to?: NuxtLinkProps['to']
    external?: boolean
  }>(),
  {
    size: 'md',
    as: 'button',
    to: undefined,
  },
)

const resolvedComponent = computed(() => {
  if (props.as === 'NuxtLink') {
    return CustomNuxtLink
  }
  return props.as
})
</script>
